const DatePicker = ({ question }) => {
  return <input placeholder="Answer" className="border rounded w-100 p-2" type="date" disabled />;
};

export default DatePicker;
